export default "__VITE_ASSET__WfPO6Tqs__"